import { Fragment, createElement } from 'react';
import { useClientOnly } from '../hooks/useClientOnly';
export function ClientOnly({
  children
}) {
  const hasMounted = useClientOnly();
  if (!hasMounted) {
    return null;
  }
  return /*#__PURE__*/createElement(Fragment, {
    children
  });
}